import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import axios from 'axios';
import { connect } from 'react-redux';
// import {Actions as TEAMACTIONS} from '../../store/actions/teamActions';
import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
import Select from 'react-select';
import _ from 'lodash';
import { TimeInputFormat, DateInputFormat } from "../common/DateComponents";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import cleanDeep from 'clean-deep';
import { format } from 'date-fns';


import { v4 as uuidv4 } from 'uuid';
import LeaveCarryoverRow from "./LeaveCarryoverRow";
import LeaveBalanceRow from "./LeaveBalanceRow";
import { PlusIcon } from "@heroicons/react/20/solid";

const LeaveBalances = ({

  leaveTypes,
  departmentOptions,
  includeFuture,
  getLeaveBalance,
  employeeOptions,
  leaveTypeOptions,
  jobTypeOptions,
  otherLeaveTypes,
  proRataLeave,
  setFutureLeaveBalance,
  balancesLoaded,
  employees,
  yearOptions,
  hasDepartments,
  viewTypeOptions,
  jurisdiction
}) => {

  const [year, setYear] = useState();
  const [employee, setEmployee] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [leaveType, setLeaveType] = useState();
  const [jobType, setJobType] = useState();
  const [viewType, setViewType] = useState(viewTypeOptions[0]);


  useEffect(() => {
    // console.log('updatingYearTo', year)
    if (year?.value) {
      getLeaveBalance(year.value);
    }
  }, [year?.value]);

  const [loaded, setLoaded] = useState(false);

  // const urlParams = new URLSearchParams(window.location.search)
  // const urlStatus = urlParams.get('status');
  // const urlTeamID = urlParams.get('teamID');
  // const urlleaveID = urlParams.get('leaveID');

  return (
    <React.Fragment>
      {
        /*<div className="content bg-gray-lighter">
            <div className="row">
              <div className="col-sm-12">
                  <div className="pull-left">
                      <h1 className="page-heading">Leave</h1>
                  </div>
                   <div className="col-sm-4 pull-right">
                      <div className="btn btn-success pull-right" onClick={() => setOpenModal(true,null)} ><PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} /> Add Leave</div>
                      <div className="btn btn-success pull-right" style={{marginRight:10}} onClick={() => getLeaveBalanceReport()} ><i className={leaveBalanceClass} style={{marginRight:5}}></i> Leave Balance Report</div>
                  </div>
              </div>
            </div>
        </div>*/
      }
      {(!employees || !balancesLoaded) &&
        <div className="content">
          <div className="row">
            <h5>Loading balances, hold on...</h5>
          </div>
        </div>
      }

      {employees && balancesLoaded &&
        <div className="content">
          <div>

            <React.Fragment>

              <div className="form-group">
                <div >
                  {hasDepartments &&
                    <div className="col-sm-3 col-xs-6">
                      <label htmlFor="material-text">Department</label>
                      <Select
                        value={selectedDepartment}
                        options={departmentOptions}
                        onChange={setSelectedDepartment}
                        isClearable={true}
                      />
                      <div className="clearfix"></div>
                    </div>
                  }
                  {jobTypeOptions &&
                    <div className="col-sm-2 col-xs-4">
                      <label htmlFor="material-text">Job Type</label>
                      <Select
                        value={jobType}
                        options={jobTypeOptions}
                        onChange={setJobType}
                        isClearable={true}
                      />
                      <div className="clearfix"></div>
                    </div>
                  }

                  {yearOptions &&
                    <div className="col-sm-2 col-xs-4">
                      <label htmlFor="material-text">Year</label>
                      <Select
                        value={year}
                        options={yearOptions}
                        onChange={setYear}
                        isClearable
                      />
                      <div className="clearfix"></div>
                    </div>
                  }

                  {viewTypeOptions &&
                    <div className="col-sm-2 col-xs-4">
                      <label htmlFor="material-text">View</label>
                      <Select
                        value={viewType}
                        options={viewTypeOptions}
                        onChange={setViewType}
                      />
                      <div className="clearfix"></div>
                    </div>
                  }

                  <div className="col-sm-3 col-xs-6" style={{ height: 61 }}>
                    <label className="css-input switch switch-sm switch-success" style={{ marginTop: 30 }}>
                      <input
                        type="checkbox"
                        onClick={(e) => {
                          setFutureLeaveBalance(e.target.checked)
                        }}
                      />
                      <span></span>
                      <label htmlFor="material-text" style={{ marginBottom: 0 }}>Include Future Leave Applications</label>
                    </label>
                  </div>

                  <div className="clearfix"></div>
                </div>
              </div>

            </React.Fragment>

            {
              employees &&
              <div className="table-responsive" style={{overflow: "scroll", minHeight: 0, height: "40vh"}}>
                <table id="table-timesheets" className="js-table-sections table table-hover">
                  <thead style={{position: "sticky", top: 0, backgroundColor: "#FFF"}}>
                    <tr>
                      <th>Team Member</th>
                      {viewType.value == 'consumed' &&
                        <>
                          <th title="Unused Vacation Leave Carried Forward">VL CF</th>
                          <th title="Vacation Leave Entitlement">VL Ent</th>
                          <th title="Vacation Leave Entitlement">VL Adj</th>
                          <th title="Vacation Leave Entitlement">TOIL</th>
                          <th title='Consumed Vacation Leave'>VL CONS</th>
                          <th title={`Paid Vacation Leave (eg Termination)`}>{`VL Paid`}</th>
                          { includeFuture ? 
                            <th title='Vacation Leave Balance, including future leave applications'>VL BAL</th>
                            :
                            <th title={`Vacation Leave Balance`}>{`VL BAL`}</th>
                          }
                          <th title="Sick Leave Consumed">SICK</th>
                          {jurisdiction === "MT" ? <th title="Half-Pay Sick Consumed">½ PAY SICK</th> : null}
                          <th title="Unpaid Sick Consumed">UNPAID SICK</th>
                        </>
                      }
                      {viewType.value !== 'consumed' &&
                        <>
                          <th title="Remaining Unused Vacation Leave Carried Forward">VL CF</th>
                          <th title={proRataLeave ? `Leave Balance remaining to date` : `Leave balances available this year`}>{proRataLeave ? `Entitled 2D` : `VL THIS YR`}</th>
                          <th title={proRataLeave ? `Leave balance remaining to date including unused carry-forward` : `Leave balance remaining this year (incl carry-forward)`}>{proRataLeave ? `Total 2D` : `TOTAL VL BAL`}</th>
                          <th title="Sick Leave Entitled">SICK</th>
                          {jurisdiction === "MT" ? <th title="Half-Pay Sick Entitled">½ PAY SICK</th> : null}
                        </>
                      }
                      {/* Custom Leave Types*/}
                      {
                        otherLeaveTypes && otherLeaveTypes.map(item =>
                          <th>{item.name}</th>
                        )
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      employees.filter(e => (!jobType?.value || String(e.employmentType) === String(jobType?.value)) && (!selectedDepartment?.value || String(e.department) === String(selectedDepartment?.value))).map(employee => (<LeaveBalanceRow key={employee.id} employee={employee} viewType={viewType} />))}
                  </tbody>
                </table>
              </div>
            }


            <div className="clearfix"></div>

          </div>
        </div>
      }

    </React.Fragment>
  );
}


const mapStateToProps = (state) => {

  const {
    leaveBalancesUpdating,
    leaveBalances,
    leaveTypes,
    leaveBalancesByType
  } = state.leave

  const { enableDepartments, departments, } = state?.company?.settings;

  const employeeListWithSalary = state && state.employees && state.employees.employeeListWithSalary

  const employeeOptions = employeeListWithSalary && employeeListWithSalary.map(employee => ({
    value: employee.id,
    label: `${employee.employeeName} ${employee.employeeSurname}`
  }))

  const leaveTypeOptions = leaveTypes && leaveTypes.map(leaveType => ({
    value: leaveType.id,
    label: leaveType.name
  }))

  const jobTypeOptions = [
    {
      value: "502",
      label: "Part-Time",
    },
    {
      value: "501",
      label: "Full-Time",
    }
  ]

  const viewTypeOptions = [
    {
      value: "consumed",
      label: "Consumed",
    },
    {
      value: "balance",
      label: "Balances",
    }
  ]

  const departmentOptions = departments?.map(department => ({
    value: department.id,
    label: department.name
  }))

  const sortedEmployees = _.orderBy(employeeListWithSalary, ["employeeName", "employeeSurname"], ["asc", "asc"])

  const otherLeaveTypeIDs = leaveBalancesByType && Object.keys(leaveBalancesByType).filter(item => !["6022", "6020"].includes(item))

  const otherLeaveTypes = leaveTypes && otherLeaveTypeIDs && otherLeaveTypeIDs.map(id => leaveTypes.find(item => item.id == id))

  console.log('otherLeaveTypes', otherLeaveTypes)

  const yearOptions = 		state?.payPeriods?.periods
			?.map((payroll) => Number(payroll?.year))
			?.filter((predicate, index, array) => {
				return array.indexOf(predicate) === index;
			})
			?.map((year) => ({
				label: year,
				value: year,
			})) || [];

  return {
    leaveTypes,
    otherLeaveTypes,
    employeeOptions,
    employees: sortedEmployees,
    balancesLoaded: !leaveBalancesUpdating && leaveBalancesByType ? true : false,
    departmentOptions,
    leaveTypeOptions,
    jobTypeOptions,
    yearOptions,
    viewTypeOptions,
    hasDepartments: enableDepartments === undefined ? !!departments?.length : enableDepartments,
    includeFuture: state?.leave?.futureLeaveBalance,
    proRataLeave: state?.leave?.leaveSettings?.proRataLeave || state?.leave?.leaveSettings?.projectedBalance,
    jurisdiction: state?.company?.settings?.jurisdiction,
  }
}

const mapDispatchToProps = dispatch => ({
  getLeaveBalance: (date) => dispatch(LEAVEACTIONS.leaveGetBalances(date)),
  setFutureLeaveBalance: (status) => dispatch(LEAVEACTIONS.setFutureLeaveBalance(status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaveBalances) 
